import { ApiConfig } from "../../../Api/Api";

export const getQuestionTypeApi = async () => {
    return await ApiConfig.get(`api/qtype`);
};